RivalIQ.module('postTags.utils', function (utils, App, Backbone, Marionette, $, _) {

    'use strict';

    utils.canShowPostTagManager = function () {
        return !RivalIQ.utils.browser.isMobile();
    };

    utils.makePostKey = function (channel, postNativeId) {
        return `${channel}.${postNativeId}`;
    };

    utils.postTagHtml = function (postTagName) {
        return RivalIQ.utils.emoji.emojify(_.escape(postTagName));
    };

    utils.getPostTagIds = function (postTagIdsStr) {
        return _.compact((postTagIdsStr || '').toString().split(','));
    };

    utils.getPostTags = function (postTagIds, postTagsById, unsorted) {
        const postTags = _(postTagIds)
            .map(function (postTagId) {
                return _.get(postTagsById, [postTagId]);
            })
            .compact()
            .map(function (postTag) {
                return _.defaults({
                    postTagHtml: utils.postTagHtml(postTag.tag_name)
                }, postTag);
            })
            .value();

        if (!unsorted) {
            postTags.sort(function (a, b) {
                return a.tag_name.localeCompare(b.tag_name);
            });
        }

        return postTags;
    };

    // Rather than redrawing our tables when hiding/showing post tags (which is quite expensive sadly),
    // just update the class on the body element and use css rules to take care of tag visibility
    // and animations.
    utils.updateBodyClass = function (inPostTagEditMode, showPostTags) {
        const $body = $('body');
        if (!_.isUndefined(inPostTagEditMode)) {
            const wasInEditMode = $body.hasClass('in-post-tags-edit-mode');

            $body.toggleClass('in-post-tags-edit-mode', inPostTagEditMode);
            if (wasInEditMode) {
                $body.addClass('leaving-post-tags-edit-mode');
            }

            if (inPostTagEditMode) {
                $body.removeClass('leaving-post-tags-edit-mode');
            }
        }

        if (!_.isUndefined(showPostTags)) {
            $body.toggleClass('show-post-tags-mode', showPostTags);
        }
    };

    utils.makePostTagName = function (postTagsById, postTagId) {
        // with AND queries, post tag id can be a comma-separated array
        const postTagIds = postTagId.split(',');
        const postTagName = _.map(postTagIds, function (tagId) {
            tagId = _.trim(tagId);

            if (postTagId === '__UNTAGGED__') {
                return 'Untagged';
            } else if (postTagId === '__SUMMARY_ROW__') {
                return 'All Posts';
            } else {
                return _.get(postTagsById, [tagId, 'tag_name'], tagId);
            }
        });

        postTagName.sort(function (a, b) {
            return a.localeCompare(b);
        });

        return postTagName.join(', ');
    };
});
